<template>
  <div class="pt-10">
    <v-row align="center" class="fill-height ma-0" justify="center">
      <v-img :src="facility.orgLogoUrl" max-height="120" max-width="100" contain></v-img>
    </v-row>
    <Loader v-if="isLoading" style="height: 200px;" />
    <v-row v-else class="mx-10 px-0 mx-0 justify-center">
      <v-col md="8" sm="12" class="pt-8" v-if="isEmailVerified">
        <h3 align="center" style="color:#71bf7a">
          <b>
            Email successfully verified
          </b>
        </h3>
      </v-col>
      <v-col md="8" sm="12" class="pt-8" v-if="isError">
        <h4 align="center" style="color:#f5574b" >
          <b>
            {{ errorMessage }}
          </b>
        </h4>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import Loader from "@/components/loader/Loader.vue";

export default {
  components: {
    Loader
  },
  data() {
    return {
      isLoading: false,
      isError: false,
      isEmailVerified: false,
      linkErrorMessage: "The link has already been used",
      invalidToken: "The link is invalid",
      verificationErrorMessage: "Unable to verify an email",
      errorMessage: ""
    };
  },

  computed: {
    facility(){
      return this.$store.state.facilityModule.selectedFacility
    }
  },

  async mounted() {
    this.isLoading = true;

    await firebase
      .firestore()
      .collection("familyHubUsers")
      .where("emailVerificationToken", "==", this.$route.params.token).get()
      .then(async (snap) => {

        if (snap.empty) {
          this.isLoading = false;
          this.setError(true, this.linkErrorMessage)
        }
        else if (snap.docs.length == 1) {

          await firebase
            .firestore()
            .collection('familyHubUsers')
            .doc(snap.docs[0].id)
            .update({
              isEmailVerified: true,
              emailVerificationToken: null,
              emailVerificationTokenSentDateTime: firebase.firestore.Timestamp.now()
            }).then(snap => {
              this.isEmailVerified = true;
            }).catch(() => {
              this.setError(true, this.verificationErrorMessage);
            }).finally(() => {
              this.isLoading = false;
            });
        }
        else if (snap.docs.length > 1) {
          this.isLoading = false;
          this.setError(true, this.invalidToken)
        }
      })
      .catch(() => {
        this.setError(true, this.verificationErrorMessage);
      }).finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    setError(state, message) {
      if (state) {
        this.isError = true;
        this.errorMessage = message;
      }
      else {
        this.isError = false;
        this.errorMessage = '';
      }
    }
  }
};
</script>
